import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

const frSelector = (state: IAppState) => state.formsRecognizerConfiguration;

const envSelector = (state: IAppState) => state.environmentState;



export const FRConfigurationSelector = createSelector(
  frSelector,
  (state: IFRGState) => state.formsRecognizerConfiguration.frConfiguration
);


export const FRConfigurationsSelector = createSelector(
  frSelector,
  (state: IFRGState) => state.formsRecognizerConfiguration.frConfigurations
);


export const EnviromentSelector = createSelector(
  envSelector,
  (state: IEnvironmentState) => state.environment
);
